module.exports = __webpack_public_path__ + "img/blank-comic-book_B098RX2RZG.1c725806.jpg";